<div class="row">
  <div class="col-md-12 ">
    <app-category-list></app-category-list>
  </div>
</div>
